import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Input, Divider } from 'antd';
import AuthShell from './AuthShell';
import { SlackLogo, GoogleLogo } from './logos';
import { requestEmailOtp, goToGoogleLogin, goToSlackLogin } from './authApi';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Enjo-style "Sign in to your account": email -> OTP, plus Slack / Google.
const TrooprSignIn = (props) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setError('');
    if (!EMAIL_RE.test(email.trim())) {
      return setError('Please enter a valid email address');
    }
    setLoading(true);
    try {
      const res = await requestEmailOtp(email.trim(), { isSignup: false });
      setLoading(false);
      if (res.data && res.data.success) {
        props.history.push({
          pathname: '/verification',
          state: { sessionId: res.data.sessionId, email: email.trim(), isSignup: false },
        });
      } else {
        setError((res.data && res.data.message) || 'Could not send code. Try again.');
      }
    } catch (e) {
      setLoading(false);
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <AuthShell>
      <h1 className="tpr-auth__title">Sign in to your account</h1>
      <p className="tpr-auth__subtitle">Use your work email to easily collaborate</p>

      <div className="tpr-auth__field">
        {error && <span className="tpr-auth__error">* {error}</span>}
        <Input
          className="tpr-auth__input"
          placeholder="name@work-email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onPressEnter={submit}
        />
      </div>

      <Button
        className="tpr-auth__primary"
        type="primary"
        loading={loading}
        onClick={submit}
      >
        Sign in with email
      </Button>

      <Divider className="tpr-auth__divider">OR</Divider>

      <div className="tpr-auth__providers">
        <Button className="tpr-auth__provider" onClick={goToSlackLogin}>
          <SlackLogo /> Continue with Slack
        </Button>
        <Button className="tpr-auth__provider" onClick={goToGoogleLogin}>
          <GoogleLogo /> Continue with Google
        </Button>
      </div>

      <div className="tpr-auth__footer">
        New to Troopr?{' '}
        <span
          className="tpr-auth__link"
          onClick={() => props.history.push('/signup')}
        >
          Create an account
        </span>
      </div>
    </AuthShell>
  );
};

export default withRouter(TrooprSignIn);
